import * as React from "react";
import Button from "@mui/material/Button";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import axiosInstance from "../../utilities/Axios";
import { useState } from "react";
import { useSnackbar } from "notistack";

export default function AlertDialogUpdate(props: {
  openAlert: boolean;
  onCloseAlert: any;
  data: any;
  action: string;
  additionalArgs?: { [key: string]: any };
}) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const updateTicket = async (id: number, args?: { [key: string]: any }) => {
    if (props.action == "processView") {
      try {
        const url = `${process.env.REACT_APP_API_ORIGIN}/v1/process/${id}`;
        const response = await axiosInstance.put(url, args);
        enqueueSnackbar("Process Update Successfully!!!", {
          variant: "success",
        });
        handleClose();
      } catch (err: any) {
        enqueueSnackbar(
          `Process Update Unsuccessful!!! ${err.response.data.error}`,
          { variant: "error" }
        );
        console.error(err);
      }
    }
  };

  const handleClose = () => {
    props.onCloseAlert();
  };
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState<DialogProps['maxWidth']>('xs');

  return (
    <div>
      <Dialog
        open={props.openAlert}
        onClose={handleClose}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirmation"}
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description">
            Are You Sure?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              updateTicket(props.data.id, props.additionalArgs);
            }}
            variant="outlined"
            autoFocus
            color="success"
          >
            Confirm
          </Button>
          <Button
            variant="outlined"
            onClick={handleClose}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
